import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import serviceUtil from './serviceUtil';

import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';

let helpers = {
  getActivitiesList(){
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/activities?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },

  getEventHistories(searchString, order, ascending, activity, activitySubType, startDate, endDate, page, perPage, recordDescriptor){
    let url = `${process.env.REACT_APP_API}/event_histories?current_company=${localStorage.current_company_id}`;

    if(order){
      url += `&order=${order}`;
      url += ascending ? ',asc' : ',desc';
    }
    url+= activity ? `&activity=${activity}` : '';
    url += activitySubType ? `&activity_sub_type=${activitySubType}` : '';
    url += searchString ? `&keywords=${searchString}` : '';
    url += recordDescriptor ? '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(recordDescriptor) : '';

    let sDate = new Date(startDate).toUTCString();
    let eDate = new Date(endDate).toUTCString();

    let utcStart = Date.parse(sDate);
    let utcEnd = Date.parse(eDate);
    utcEnd += 24 * 60 * 60 * 1000 -1;

    let offset = (new Date().getTimezoneOffset() * 60 * 1000);

    utcStart += offset;
    utcEnd += offset;

    url += startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
    url += endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';

    if (page && perPage) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }

    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getProjectActivity(project_id, options){
    let url = `${process.env.REACT_APP_API}/event_histories/project_activity?current_company=${localStorage.current_company_id}&project_id=${project_id}`;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  createActivityLogEntry(activity, activity_sub_type, body, eventMetadatum) {
    if (!activity || !activity_sub_type) {
      return 'success';
    }
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/event_histories?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        activity_id: activity.id,
        activity_sub_type_id: activity_sub_type.id,
        body: body,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return 'success';
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/activityLogServices.js